import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, ShieldAlert } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { useAuth } from '../contexts/AuthContext';
export function UnauthorizedPage() {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  const getDefaultRoute = () => {
    switch (user?.role) {
      case 'super_admin':
        return '/admin/dashboard';
      case 'ketua_chapter':
      case 'ketua_student_chapter':
        return '/chapter/dashboard';
      case 'komite_pusat':
        return '/committee/dashboard';
      case 'koordinator_acara':
        return '/events/manage';
      case 'bendahara':
        return '/finance/dashboard';
      default:
        return '/dashboard';
    }
  };
  return <div className="min-h-screen bg-white flex items-center justify-center px-4" data-id="element-5221">
      <div className="max-w-md w-full text-center" data-id="element-5222">
        {/* 403 Illustration */}
        <div className="mb-8" data-id="element-5223">
          <div className="relative" data-id="element-5224">
            <h1 className="text-9xl font-bold text-neutral-200" data-id="element-5225">403</h1>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-5226">
              <ShieldAlert className="w-24 h-24 text-warning" data-id="element-5227" />
            </div>
          </div>
        </div>

        {/* Message */}
        <h2 className="text-2xl font-semibold text-neutral-900 mb-3" data-id="element-5228">
          Akses Ditolak
        </h2>
        <p className="text-neutral-600 mb-8" data-id="element-5229">
          Anda tidak memiliki izin untuk mengakses halaman ini. Silakan hubungi
          administrator jika Anda merasa ini adalah kesalahan.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-5230">
          <Button variant="secondary" onClick={() => navigate(-1)} className="flex items-center justify-center" data-id="element-5231">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-5232" />
            Kembali
          </Button>
          <Button onClick={() => navigate(getDefaultRoute())} className="flex items-center justify-center" data-id="element-5233">
            <Home className="w-4 h-4 mr-2" data-id="element-5234" />
            Ke Halaman Utama
          </Button>
        </div>

        {/* Help Text */}
        <p className="text-sm text-neutral-500 mt-8" data-id="element-5235">
          Butuh bantuan?{' '}
          <a href="mailto:support@atios.or.id" className="text-atios-primary hover:underline" data-id="element-5236">
            Hubungi Support
          </a>
        </p>
      </div>
    </div>;
}